module.exports = __webpack_public_path__ + "static/media/Avatar5.6d5424a6.svg";